import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

const SettingsPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Ayarlar" />
      <div className="card">
        <div className="card-body">
          <h5>Ayarlar</h5>
          <p>Bu sayfa yakında eklenecek.</p>
        </div>
      </div>
    </MasterLayout>
  );
};

export default SettingsPage;

